import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { skillCategories } from "../constants/skills";

function About() {
  const skillDiv = (skill) => (
    <Col
      key={skill.name}
      md="6"
      lg="3"
      className="my-3"
      data-aos="zoom-in"
      data-aos-duration="1000"
    >
      <div className="d-flex align-items-center justify-content-center">
        <div className="d-flex align-items-center justify-content-center skill-div px-5 py-3">
          <div>
            <img src={skill.url} alt={skill.name} className="skill-img" />
            <h5 className="fw-bold text-white-50 text-center mt-3">
              {skill.name}
            </h5>
          </div>
        </div>
      </div>
    </Col>
  );

  return (
    <div className="w-100vw mb-5">
      <Container>
        <div
          className="position-relative my-5 py-5 text-center"
          data-aos="fade-up"
          data-aos-duration="1000"
        >
          <h1 className="bolder fg-heading text-white mb-0">
            TECH <span className="bolder primary-color">STACK</span>
          </h1>
          <h1 className="bolder bg-title">Resume</h1>
        </div>

        <Row className="mt-5 pt-5">
          {skillCategories.map((category) => (
            <React.Fragment key={category.stack}>
              <h3
                className="bolder text-center text-white mb-5"
                data-aos="fade-up"
                data-aos-duration="1000"
              >
                {category.stack}
                <Row>{category.skills.map((skill) => skillDiv(skill))}</Row>
              </h3>
            </React.Fragment>
          ))}
        </Row>
      </Container>
    </div>
  );
}

export default About;
